export default {
    getAccountName(state, getters, rootState, rootGetters) {
        return account => {
            let foundIndex;
            let accountName = 'Other';

            const personOne = rootGetters['individuals/personOne'];
            const personTwo = rootGetters['individuals/personTwo'];
            const personTwoExists = rootGetters['individuals/personTwoExists'];

            const iavAccountOwnerTypes = rootState.constants.iavAccountOwnerTypes;

            switch(account.owner) {
                case iavAccountOwnerTypes.individual:
                    if (account.individual_id === personOne.id) {
                        accountName = personOne.name;
                    } else if (personTwoExists && account.individual_id === personTwo.id) {
                        accountName = personTwo.name;
                    }

                    break;
                case iavAccountOwnerTypes.joint:
                    accountName = 'Joint';

                    break;
                case iavAccountOwnerTypes.trust:
                    accountName = 'Trust';

                    break;
                case iavAccountOwnerTypes.business:
                    accountName = 'Business';

                    break;
                case iavAccountOwnerTypes.beneficiary:
                    foundIndex = rootState.beneficiaries.beneficiaries.findIndex(i => i.id === account.beneficiary_id);
                    if (foundIndex !== undefined) {
                        accountName = rootState.beneficiaries.beneficiaries[foundIndex].first_name;
                    }

                    break;
            }

            return accountName;
        }
    },
    performanceBenchmarkOptions(state) {
        if (state.performanceOptions == null){
            return null;
        }
        return state.performanceOptions.filter((option) => {
            return option.type === 1;
        })
    },
    isClientHouseholdWithNoIncomePlaner(state) {
        return state.household.household_type === 2 && state.household.plan_ready == false
    }
}
